var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeCarousel"},[_c('el-carousel',_vm._l((_vm.carouselData),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"homeCarouselImg",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }